import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Grid, Header, Icon, Modal } from 'semantic-ui-react';
import collections from '../../api/collections';
import { UIFileFormat } from '../../config/dates';
import { handleDownload } from '../../helpers/downloads';
import { showBankingCommentsModal, showCollectionBreakdownModal, toggleCollectionModalSummary, showCollectionModal, showSiteVarianceHistoryModal } from '../../redux/actions/modals';
import DataGrid from '../shared/DataGrid';
import DownloadButton from '../shared/DownloadButton';
import SummaryButton from '../shared/SummaryButton';

class CollectionModal extends React.Component {
  
  state = {
    showSummary: false,
    loading: false,
    loadingReport: false,
  }

  handleVarianceHistory = () => {
    this.props.showSiteVarianceHistoryModal(true);
  }

  onRowClick = (row) => {
    const fn = this.props.modal.isPerformance ? collections.getBankingPerformanceByEgm : collections.getBankingWeekByEgm;
    const { detailRef } = row;

    if (detailRef && detailRef.length > 0) {
      this.setState({ loading: true }, () => {
        fn(detailRef).then(
          result => {
            this.setState({ loading: false })
            this.props.showCollectionBreakdownModal(
              { detailRef, ...result },
              () => this.onRowClick({ detailRef }), 
              async () => {
                await this.props.modal.onRefresh()
              }
            );
          },
          error => this.setState({ loading: false })
        );
      });
    }
  }

  handleClose = (refresh) => {
    this.props.modal.onClose();
    this.props.showCollectionModal(false);
  }

  handleViewComments = () => {
    const { operator, periodId, siteId } = this.props.modal;
   
    this.setState({ loading: true }, () => {
      collections.getComments(operator, periodId, siteId).then(
        result => this.setState({ loading: false }, () => this.props.showBankingCommentsModal(true, result)),
        () => this.setState({ loading: false })
      )
    })
  }

  requestFile = (fn, fileName) => {
     this.setState({ loadingReport: true }, () => {
      fn(this.props.modal.batchId).then(
        response => this.setState({ loadingReport: false }, () => handleDownload(fileName, response)),
        () => this.setState({ loadingReport: false })
      )
    })   
  }

  handleVariancePdfClick = () => {
    const fn = this.props.modal.isPerformance ? collections.getPerformanceVariancePdf : collections.getBankingVariancePdf;
    const prefix = 'Collection Variance Report';
    this.requestFile(fn, prefix)
  }

  handleSummaryPdfClick = () => {
    const fn = this.props.modal.isPerformance ? collections.getPerformanceSummaryPdf : collections.getBankingSummaryPdf;
    const prefix = this.props.modal.isPerformance ? 'Collection Net Income Report' : 'Collection Week Banking Report';
    this.requestFile(fn, prefix)
  }

  render() {
    const { showFloatsGrid } = this.props.modal;
    const { showSummary } = this.state;

    const rightWidth = showSummary ? 13 : 16;

    return (
        <Modal
            open={this.props.modal.open}
            onClose={this.handleClose}
            size='fullscreen'
            closeIcon
            style={{ height: "80%"}}
        >
          <Modal.Header>{this.props.modal.title}</Modal.Header>
          <Modal.Content className="h-100">
            <Grid className="height-100 flex-container">
              <Grid.Row>
                <Grid.Column width="8">
                  { !this.props.modal.isPerformance && <SummaryButton active={showSummary} className="mr-1" onClick={() => this.setState({ showSummary }) } /> }
                  <Header size="small" className="d-inline">
                  {this.props.modal.siteText} - {this.props.modal.weekText}
                  </Header>
                </Grid.Column>
                <Grid.Column width="8" textAlign="right">
                  <Button color="teal" onClick={this.handleViewComments}>View Comments</Button>
                  { /* <Button color="blue" onClick={this.handleVarianceHistory}>Variance History</Button> */ }
                  {this.props.modal.optionShowViewCommentsButton && <Button color="blue" onClick={this.handleViewComments}>View Comments</Button> }
                  <Dropdown 
                    direction="left"
                    icon={null}
                    trigger={<Button color="teal" icon labelPosition="right" loading={this.state.loadingReport}><Icon name="caret down" /> Reports</Button>} 
                  >
                    <Dropdown.Menu>
                      <Dropdown.Item text={ this.props.modal.isPerformance ? 'Net Income PDF' : 'Banking Report PDF' } onClick={this.handleSummaryPdfClick} />
                      <Dropdown.Item text='Collection Variance PDF' onClick={this.handleVariancePdfClick} />
                      <Dropdown.Item text='Machine Performance PDF' onClick={() => this.requestFile(collections.getMachinePerformancePdf, "Machine Performance Analysis Report")} />
                      <Dropdown.Item text='Machine Performance CSV' onClick={() => this.requestFile(collections.getMachinePerformanceCsv, "Machine Performance Analysis Report")} />
                    </Dropdown.Menu>
                  </Dropdown>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={ (this.props.modal.isPerformance || !showFloatsGrid) ? "16" : "13" }>
                  <DataGrid
                    headings={this.props.modal.categoryGrid.headerDef}
                    data={this.props.modal.categoryGrid.data}
                    loading={this.state.loading}
                    rowDef={this.props.modal.categoryGrid.rowDef}
                    onRowClick={() => { }}
                    style={{ maxHeight: "120px"}}
                  />
                </Grid.Column>
                { showFloatsGrid && 
                <Grid.Column width="3">
                  <DataGrid
                    headings={this.props.modal.siteFloatGrid.headerDef}
                    data={this.props.modal.siteFloatGrid.data}
                    rowDef={this.props.modal.siteFloatGrid.rowDef}
                    loading={this.state.loading}
                    onRowClick={() => { }}
                    style={{ maxHeight: "120px"}}
                  />
                </Grid.Column>
                }
              </Grid.Row>
              <Grid.Row className="flex-stretch">
                { showSummary && 
                <Grid.Column width="3" className='flex-stretch gs-flex-container-vertical'>
                  <DataGrid
                    headings={this.props.modal.summaryGrid.headerDef}
                    data={this.props.modal.summaryGrid.data}
                    rowDef={this.props.modal.summaryGrid.rowDef}
                    loading={this.state.loading}
                    fullHeight
                    onRowClick={() => { }}
                  />
                </Grid.Column>
                }
                <Grid.Column width={rightWidth} className='flex-stretch gs-flex-container-vertical'>
                  <DataGrid
                    headings={this.props.modal.detailGrid.headerDef}
                    data={this.props.modal.detailGrid.data}
                    rowDef={this.props.modal.detailGrid.rowDef}
                    loading={this.state.loading}
                    fullHeight
                    onRowClick={this.onRowClick}
                  />
                </Grid.Column>
              </Grid.Row>
              { !this.props.modal.isPerformance && 
              <Grid.Row>
                <Grid.Column width="16">
                  <Header size="small">Kiosk/Cash Desk Summary</Header>
                  <DataGrid
                    headings={this.props.modal.kioskGrid.headerDef}
                    data={this.props.modal.kioskGrid.data}
                    rowDef={this.props.modal.kioskGrid.rowDef}
                    onRowClick={() => { }}
                    loading={this.state.loading}
                    style={{ maxHeight: "120px" }}
                  />
                </Grid.Column>
              </Grid.Row>
              }
            </Grid>
          </Modal.Content>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.collectionModal,
    breakdown: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, { showBankingCommentsModal, showCollectionBreakdownModal, showSiteVarianceHistoryModal, showCollectionModal })(CollectionModal);


